import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { verify, setStoredToken, getRolesFromAccessToken, isStaffRole } from '@/api/auth';
import { AUTH_RATE_LIMIT_PATHS, applyAuthRateLimitFromError, formatAuthRateLimitMessage, getAuthCooldownRemaining, } from '@/api/authRateLimit';
import { isAxiosStatus, parseApiErrorMessage } from '@/api/errors';
import { useAuthCooldown } from '@/hooks/useAuthCooldown';
import './Auth.css';
export function VerifyPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const emailFromState = location.state?.email ?? '';
    const redirectTo = location.state?.redirectTo ?? '/me/profile';
    const cooldown = useAuthCooldown(AUTH_RATE_LIMIT_PATHS.verify);
    const [email, setEmail] = useState(emailFromState);
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const displayError = cooldown > 0 ? formatAuthRateLimitMessage(cooldown) : error;
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (getAuthCooldownRemaining(AUTH_RATE_LIMIT_PATHS.verify) > 0)
            return;
        setError('');
        const emailToUse = emailFromState || email.trim();
        if (!emailToUse) {
            setError('Введите email');
            return;
        }
        setLoading(true);
        try {
            const res = await verify({ email: emailToUse, code });
            setStoredToken(res.accessToken);
            const roles = getRolesFromAccessToken(res.accessToken);
            if (isStaffRole(roles)) {
                window.location.assign('/admin');
                return;
            }
            navigate(redirectTo, { replace: true });
        }
        catch (err) {
            if (applyAuthRateLimitFromError(err, AUTH_RATE_LIMIT_PATHS.verify)) {
                setError('');
                return;
            }
            setError(isAxiosStatus(err, 401)
                ? 'Неверный или истёкший код'
                : parseApiErrorMessage(err, 'Ошибка проверки кода'));
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx("div", { className: "auth-page", children: _jsxs("div", { className: "auth-card", children: [_jsx("h1", { className: "auth-title", children: "\u0414\u0432\u0443\u0445\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0430\u044F \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430" }), _jsx("p", { className: "auth-subtitle", children: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u0438\u0437 \u043F\u0438\u0441\u044C\u043C\u0430" }), emailFromState && (_jsxs("p", { className: "auth-2fa-hint", children: ["\u041A\u043E\u0434 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430 ", _jsx("strong", { children: emailFromState })] })), _jsx("p", { className: "auth-2fa-hint", children: "\u0415\u0441\u043B\u0438 \u043F\u0438\u0441\u044C\u043C\u0430 \u043D\u0435\u0442 - \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0430\u043F\u043A\u0443 \u00AB\u0421\u043F\u0430\u043C\u00BB." }), displayError && _jsx("div", { className: "auth-error", children: displayError }), _jsxs("form", { onSubmit: handleSubmit, className: "auth-form", children: [!emailFromState && (_jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "verify-email", children: "Email" }), _jsx("input", { id: "verify-email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "user@example.com", required: true })] })), _jsxs("div", { className: "auth-field", children: [_jsx("label", { htmlFor: "verify-code", children: "\u041A\u043E\u0434 \u0438\u0437 \u043F\u0438\u0441\u044C\u043C\u0430" }), _jsx("input", { id: "verify-code", type: "text", value: code, onChange: (e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6)), placeholder: "123456", minLength: 6, maxLength: 6, inputMode: "numeric", autoComplete: "one-time-code", required: true }), _jsx("span", { className: "auth-hint", children: "6 \u0446\u0438\u0444\u0440" })] }), _jsx("button", { type: "submit", className: "auth-submit", disabled: loading || cooldown > 0, children: cooldown > 0
                                ? formatAuthRateLimitMessage(cooldown)
                                : loading
                                    ? 'Проверка…'
                                    : 'Войти' })] }), _jsx("p", { className: "auth-footer", children: _jsx(Link, { to: "/login", children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u0432\u0445\u043E\u0434\u0443" }) })] }) }));
}
